export const sequenceMock = {
  "colourLUT": ["#000000", "#FFFFFF", "#000000", "#FF0000", "#00FF00", "#0000FF", "#FF00FF", "#00FFFF", "#FFFF00"],
  "colourStrLUT": ["no", "wh", "bk", "rd", "gr", "bl", "mg", "cy", "yl"],
  "length": "10",
  "seq": [1, 2, 5, 4, 6, 8, 4, 7, 6, 4],
  "singleString": "['wh', 'bk', 'bl', 'gr', 'mg', 'yl', 'gr', 'cy', 'mg', 'gr']"
}
